export const defaultPermissions = {
    USER: []
};



// WEBPACK FOOTER //
// ./src/app/acl/default-permissions.ts